import { all } from "redux-saga/effects";

import patientSaga from "./patientSaga";
import healthCoachSaga from "./healthCoachSaga";
import assessmentSaga from "./assessmentSaga";
import dietSaga from "./dietSaga";
import consultationSaga from "./consultationSaga";

function* rootSaga() {
  yield all([
    patientSaga(),
    healthCoachSaga(),
    assessmentSaga(),
    dietSaga(),
    consultationSaga()
  ]);
}

export default rootSaga;
